<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-row v-if="model.prontuario">
            <rkm-col cols="6">
                <rkm-form-input
                    disabled
                    label="ID Cidadão"
                    v-model="model.prontuario"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-datepicker
                    disabled
                    label="Data para atualização do cadastro"
                    v-model="model.data_atualizacao_cadastro"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.cpf_numero"
                    @blur="handleCpfBlur"
                    label="CPF"
                    v-mask="utils.mask.cpf"
                    v-model="model.cpf_numero"
                />
            </rkm-col>

            <rkm-col cols="9">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.nome_social"
                    label="Nome social"
                    uppercase
                    v-model="model.nome_social"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :disabled="!model.nome_social"
                    :options="form.preferencias_nome"
                    :validations="validations.preferencia_nome_id"
                    label="Prefere ser chamado pelo"
                    text-field="descricao"
                    v-model="model.preferencia_nome_id"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-datepicker
                    :max-date="additionals.data_atual"
                    :validations="validations.data_nascimento"
                    label="Data de nascimento"
                    v-model="model.data_nascimento"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="form.sexos"
                    :validations="validations.sexo_id"
                    label="Sexo"
                    show-default-option
                    text-field="descricao"
                    v-model="model.sexo_id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-datepicker
                    :max-date="additionals.data_atual"
                    :min-date="others.moment(model.data_nascimento).format('DD/MM/YYYY')"
                    label="Data de óbito"
                    right
                    v-model="model.data_obito"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.estados_civis"
                    label="Estado civil"
                    show-default-option
                    text-field="descricao"
                    v-model="model.estado_civil_id"
                />
            </rkm-col>

            <rkm-col cols="8">
                <rkm-form-input
                    :disabled="model.estado_civil_id !== enums.EstadoCivil.CASADO && model.estado_civil_id !== enums.EstadoCivil.CONVIVENTE"
                    :validations="validations.nome_conjuge"
                    label="Cônjuge/Convivente"
                    uppercase
                    v-model="model.nome_conjuge"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :disabled="model.desconhece_mae"
                    :validations="validations.nome_mae"
                    label="Nome da mãe"
                    uppercase
                    v-model="model.nome_mae"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox v-model="model.desconhece_mae">
                                Desconhece
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :disabled="model.desconhece_pai"
                    :validations="validations.nome_pai"
                    label="Nome do pai"
                    uppercase
                    v-model="model.nome_pai"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox v-model="model.desconhece_pai">
                                Desconhece
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.classificacoes"
                    :validations="validations.classificacao_id"
                    label="Classificação"
                    show-default-option
                    text-field="descricao"
                    v-model="model.classificacao_id"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.locais_nascimento"
                    :validations="validations.local_nascimento_id"
                    label="Local de nascimento"
                    show-default-option
                    text-field="descricao"
                    v-model="model.local_nascimento_id"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :disabled="model.local_nascimento_id !== enums.LocalNascimento.EM_OUTRO_PAIS"
                    :options="form.paises"
                    :validations="validations.pais_nascimento_id"
                    label="País de nascimento"
                    show-default-option
                    v-model="model.pais_nascimento_id"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :disabled="model.local_nascimento_id !== enums.LocalNascimento.EM_OUTRO_PAIS || !model.pais_nascimento_id"
                    :options="nacionalidades"
                    :validations="validations.nacionalidade_id"
                    label="Nacionalidade"
                    show-default-option
                    text-field="descricao"
                    v-model="model.nacionalidade_id"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-datepicker
                    :disabled="model.nacionalidade_id !== enums.Nacionalidade.NATURALIZADO_BRASILEIRO"
                    :max-date="additionals.data_atual"
                    :min-date="others.moment(model.data_nascimento).format('DD/MM/YYYY')"
                    :validations="validations.data_naturalizacao"
                    label="Data de naturalização"
                    v-model="model.data_naturalizacao"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :disabled="!model.local_nascimento_id || model.local_nascimento_id !== enums.LocalNascimento.EM_OUTRO_MUNICIPIO"
                    :options="form.estados"
                    :validations="validations.estado_nascimento_id"
                    label="UF de nascimento"
                    show-default-option
                    text-field="uf"
                    v-model="model.estado_nascimento_id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input-autocomplete
                    :disabled="!model.estado_nascimento_id || model.local_nascimento_id !== enums.LocalNascimento.EM_OUTRO_MUNICIPIO"
                    :fields="fields.municipioNascimento"
                    :repository="repositories.comum.municipio"
                    :request-params="{
                        local_nascimento_id: model.local_nascimento_id,
                        estado_id: model.estado_nascimento_id,
                    }"
                    :selected-text="model.municipio_nascimento_nome"
                    :validations="validations.municipio_nascimento_id"
                    label="Município de nascimento"
                    v-model="model.municipio_nascimento_id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.racas_cores"
                    :validations="validations.raca_cor_id"
                    label="Raça/cor"
                    show-default-option
                    text-field="descricao"
                    v-model="model.raca_cor_id"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="model.raca_cor_id !== enums.RacaCor.INDIGENA || model.local_nascimento_id === enums.LocalNascimento.EM_OUTRO_PAIS"
                    :options="form.etnias_indigena"
                    :validations="validations.etnia_indigena_id"
                    label="Etnia indígena"
                    show-default-option
                    text-field="descricao"
                    v-model="model.etnia_indigena_id"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.deficiencias"
                    label="Pessoa com deficiência (PcD)"
                    show-default-option
                    text-field="descricao"
                    v-model="model.deficiencia_id"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="5">
                <rkm-form-input
                    :disabled="model.deficiencia_id !== enums.Deficiencia.OUTRA"
                    :validations="validations.deficiencia_outra"
                    label="Outra (PcD)"
                    uppercase
                    v-model="model.deficiencia_outra"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="form.mobilidades_reduzidas"
                    label="Mobilidade reduzida"
                    show-default-option
                    text-field="descricao"
                    v-model="model.mobilidade_reduzida_id"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Enums.
import {
    Classificacao,
    Deficiencia,
    EstadoCivil,
    LocalNascimento,
    Nacionalidade,
    Pais,
    PreferenciaNome,
    RacaCor,
} from '@/enums'

// Mixins.
import {error, notification} from '@/mixins'

// Utils.
import format from '@/utils/format'
import mask from '@/utils/mask'
import unmask from '@/utils/unmask'

// Others.
import moment from 'moment'

// Vee validate rules.
import cpf from '@/plugins/vee-validate/rules/cpf'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({cliente: 'getCliente'}),
        fields() {
            return {
                municipioNascimento: [
                    {key: 'nome', name: 'cadastro_municipio.nome'},
                ],
            }
        },
        validations() {
            return {
                sexo_id: {required: true},
                classificacao_id: {required: true},
                local_nascimento_id: {required: true},
                pais_nascimento_id: {required: true},
                nacionalidade_id: {required: true},
                estado_nascimento_id: {required: true},
                municipio_nascimento_id: {required: true},
                raca_cor_id: {required: true},
                etnia_indigena_id: {required: true},
                cpf_numero: {cpf: true},
                nome: {
                    required: true,
                    nome: true,
                    min: 3,
                    max: 150,
                },
                nome_social: {
                    min: 3,
                    max: 150,
                },
                data_nascimento: {required: true},            
                nome_mae: {
                    required: true,
                    nome: true,
                    min: 3,
                    max: 150,
                },
                nome_pai: {
                    required: true,
                    nome: true,
                    min: 3,
                    max: 150,
                },
                nome_conjuge: {
                    required: true,
                    nome: true,
                    min: 3,
                    max: 150,
                },
                deficiencia_outra: {
                    required: true,
                    min: 3,
                    max: 50,
                },
            }
        },
        nacionalidades() {
            if (this.model.local_nascimento_id === this.enums.LocalNascimento.EM_OUTRO_PAIS) {
                return this.form.nacionalidades.filter(n => n.id !== this.enums.Nacionalidade.BRASILEIRO)
            }
            return this.form.nacionalidades
        }
    },
    data: () => ({
        enums: {
            Classificacao,
            Deficiencia,
            EstadoCivil,
            LocalNascimento,
            Nacionalidade,
            Pais,
            PreferenciaNome,
            RacaCor,
        },
        others: {cpf, moment},
        utils: {format, mask, unmask},
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions([
            'setLoading',
            'unsetLoading'
        ]),
        handleCpfBlur(event) {
            const cpf_numero = this.utils.unmask.cpf(event.target.value)

            if (cpf_numero && this.others.cpf.validate(cpf_numero)) {
                if (!this.model.prontuario) {
                    this.setLoading('cadastro-cidadao-form')

                    this.repositories.cadastro.usuario.index({cpf_numero: cpf_numero})
                        .then(({data}) => {
                            if (data.length > 0) {
                                const usuario = data[0]

                                this.showPrimaryConfirmation(
                                    'Confirmação',
                                    `
                                        CPF já cadastrado para o(a) usuário(a) <strong>${usuario.nome}</strong>, nascido(a) em 
                                        <strong>${this.others.moment(usuario.data_nascimento).format('DD/MM/YYYY')}</strong>.
                                        Deseja utilizar os dados desse(a) usuário(a) no cidadão?
                                    `,
                                    async () => {
                                        this.model.nome = usuario.nome                                 
                                        this.model.data_nascimento = usuario.data_nascimento
                                        this.model.sexo_id = usuario.sexo_id
                                        this.model.telefone_residencial = this.utils.format.telefone(usuario.telefone_residencial)
                                        this.model.telefone_celular = this.utils.format.celular(usuario.telefone_celular)
                                        this.model.telefone_recado = this.utils.format.telefone(usuario.telefone_recado)
                                        this.model.email = usuario.email
                                        this.model.escolaridade_id = usuario.escolaridade_id
                                    },
                                    null,
                                    null,
                                )
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading('cadastro-cidadao-form'))
                }
            }
        },
        validate() {
            return this.$refs.RkmForm.validate()
        },
    },
    mixins: [error, notification],
    props: {
        additionals: {type: Object, required: true},
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
    watch: {
        'model.estado_civil_id'(value) {
            if (value !== this.enums.EstadoCivil.CASADO && value !== this.enums.EstadoCivil.CONVIVENTE) {
                this.model.nome_conjuge = null
            }
        },
        'model.classificacao_id'(newValue, oldValue) {
            if (this.model.logradouro_id && ((newValue === this.enums.Classificacao.OUTRO_MUNICIPIO) || (oldValue === this.enums.Classificacao.OUTRO_MUNICIPIO))) {
                this.showWarningConfirmation(
                    'Confirmação',
                    'Ao alterar a classificação do cidadão, os dados de endereço serão excluídos, deseja continuar?',
                    async () => {
                        this.model.pais_id = this.enums.Pais.BRASIL
                        this.model.logradouro_id = null
                        this.model.estado_id = null
                        this.model.logradouro_tipo_id = null
                        this.model.loteamento_id = null
                        this.model.zona_id = null
                        this.model.logradouro_cep = null
                        this.model.municipio_nome = null
                        this.model.bairro_nome = null
                        this.model.logradouro_nome = null
                        this.model.numero = null
                        this.model.sem_numero = false
                        this.model.loteamento_nome = null
                        this.model.complemento = null
                        this.model.ponto_referencia = null
                    },
                    async () => {this.model.classificacao_id = oldValue},
                )
            }
        },
        'model.local_nascimento_id'(value) {
            if (value !== this.enums.LocalNascimento.EM_OUTRO_PAIS ) {
                this.model.pais_nascimento_id = this.enums.Pais.BRASIL
                this.model.nacionalidade_id = this.enums.Nacionalidade.BRASILEIRO

                if (value === this.enums.LocalNascimento.NESTE_MUNICIPIO) {
                    this.model.estado_nascimento_id = this.cliente.municipio.estado.id
                    this.model.municipio_nascimento_id = this.cliente.municipio.id
                    this.model.municipio_nascimento_nome = this.cliente.municipio.nome
                } else {
                    this.model.estado_nascimento_id = null
                    this.model.municipio_nascimento_id = null
                    this.model.municipio_nascimento_nome = null
                }
            } else {
                if (value === this.enums.LocalNascimento.EM_OUTRO_PAIS) {                    
                    this.model.etnia_indigena_id = null
                }

                this.model.pais_nascimento_id = null
                this.model.nacionalidade_id = null
                this.model.estado_nascimento_id = null
                this.model.municipio_nascimento_id = null
                this.model.municipio_nascimento_nome = null
            }
        },
        'model.pais_nascimento_id'(value) {
            if (value === null) {
                this.model.nacionalidade_id = null
            }
        },
        'model.nacionalidade_id'(value) {
            if (value !== this.enums.Nacionalidade.NATURALIZADO_BRASILEIRO) {
                this.model.data_naturalizacao = null
            }
        },
        'model.raca_cor_id'(value) {
            if (value !== this.enums.RacaCor.INDIGENA) {
                this.model.etnia_indigena_id = null
            }
        },
        'model.deficiencia_id'(value) {
            if (value !== this.enums.Deficiencia.OUTRA) {
                this.model.deficiencia_outra = null
            }
        },
        'model.nome_social'(value) {
            if (!value) {
                this.model.preferencia_nome_id = this.enums.PreferenciaNome.NOME
            }
        },
        'model.desconhece_mae'(value) {
            if (value === true) {
                this.model.nome_mae = null
            }
        },
        'model.desconhece_pai'(value) {
            if (value === true) {
                this.model.nome_pai = null
            }
        },
    },
}
</script>